import type { ReactElement } from 'react';
import React from 'react';
import './styles.scss';

export default function PrintPageBreaker(): ReactElement {
  return <div className="print-page-breaker" />;
}
